// action - state management
import { LOGIN, LOGOUT, REGISTER } from './actions';
import { InitialLoginContextProps } from 'types/auth';

// ==============================|| ACCOUNT REDUCER ||============================== //

interface AccountReducerActionProps {
    type: string;
    payload?: InitialLoginContextProps;
}

const initialState: InitialLoginContextProps = {
    isLoggedIn: false,
    isInitialized: false,
    account: null
};

// eslint-disable-next-line
const accountReducer = (state = initialState, action: AccountReducerActionProps) => {
    switch (action.type) {
        case REGISTER: {
            const { account } = action.payload!;
            return {
                ...state,
                account
            };
        }
        case LOGIN: {
            const { account } = action.payload!;
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                account
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                account: null
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
